import React from "react";
import RouterComponent from "./router";
import { useDetackMetaMask } from "./hooks/useDetachMetaMask";
import { useAppSelector } from "./redux/store";
export const App: React.FC = () => {
  const { loadingAtBegining } = useAppSelector((state) => state.systemState);
  useDetackMetaMask();
  return loadingAtBegining ? null : <RouterComponent />;
};

export default React.memo(App);
